<script lang="ts">
  let { visible = false, text = '' }: { visible?: boolean; text?: string } = $props();
</script>

{#if visible}
  <div class="spinner-overlay visible" role="status" aria-live="polite">
    <div class="spinner-ring"></div>
    <p class="spinner-text">{text}</p>
  </div>
{/if}
